import { Info24px } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { OnOffSwitch, Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { ICampaignSettingField } from "app/pages/digital-marketing/generative-ai/llm-tracker/menu/types";

interface IEmailUpdatesSettingProps extends ICampaignSettingField {
    isSubscribed: boolean;
    onToggle: (value: boolean) => void;
}

export const EmailUpdatesSetting = ({ isSubscribed, onToggle, isReadOnly }: IEmailUpdatesSettingProps) => (
    <Flex
        flexDirection="column"
        gap="12px"
    >
        <Flex
            alignItems="center"
            gap="4px"
        >
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[500]}
            >
                {translate("llmTracker.campaignQuery.edit.emailUpdates.title")}
            </Text>
            <Tooltip content={translate("llmTracker.campaignQuery.edit.emailUpdates.tooltip")}>
                <Info24px
                    size="sm"
                    color={colorsPalettes.carbon[200]}
                />
            </Tooltip>
        </Flex>
        <Flex
            alignItems="center"
            justifyContent="space-between"
            padding="12px 16px"
            borderRadius="8px"
            background={colorsPalettes.carbon[25]}
            data-automation="llm-tracker-email-updates-toggle"
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[500]}
            >
                {translate("llmTracker.campaignQuery.edit.emailUpdates.weeklySummary")}
            </Text>
            <OnOffSwitch
                isDisabled={isReadOnly}
                isSelected={isSubscribed}
                onClick={() => onToggle(!isSubscribed)}
            />
        </Flex>
    </Flex>
);
